import { render, staticRenderFns } from "./TelephoneInput.vue?vue&type=template&id=13ded416&scoped=true&"
import script from "./TelephoneInput.vue?vue&type=script&lang=ts&"
export * from "./TelephoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./TelephoneInput.vue?vue&type=style&index=0&id=13ded416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ded416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ded416')) {
      api.createRecord('13ded416', component.options)
    } else {
      api.reload('13ded416', component.options)
    }
    module.hot.accept("./TelephoneInput.vue?vue&type=template&id=13ded416&scoped=true&", function () {
      api.rerender('13ded416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/TelephoneInput.vue"
export default component.exports